<template>
  <div class="single-item pl-sm-2 pl-md-3 d-inline-block">
    <div class="select-user-option" @click="opened = !opened">
      <div
        class="ddOutOfVision"
        id="countries_msddHolder"
        style="height: 0px; overflow: hidden; position: absolute;"
      >
        <select id="countries" name="countries" tabindex="-1">
          <option
            v-for="platform in platforms"
            :key="platform.value"
            :value="platform.value"
            >{{ platform.title }}</option
          >
        </select>
      </div>
      <div
        class="dd ddcommon borderRadius"
        id="countries_msdd"
        tabindex="0"
        style="width: 109px;"
      >
        <div class="ddTitle borderRadiusTp">
          <span class="divider"></span><span class="ddArrow arrowoff"></span
          ><span class="ddTitleText " id="countries_title"
            ><img :src="selected.icon" class="flag ad fnone"/><span
              class="ddlabel"
              >{{ selected.title }}</span
            ><span class="description" style="display: none;"></span
          ></span>
        </div>
        <div
          class="ddChild ddchild_ border shadow"
          id="countries_child"
          style="position: absolute; visibility: visible; height: 139px; top: 24px;"
          :style="{
            'z-index': opened ? 9999 : 1,
            display: opened ? '' : 'none',
          }"
        >
          <ul>
            <li
              class="enabled _msddli_"
              v-for="platform in platforms"
              :key="platform.value"
              :title="platform.title"
              :value="platform.value"
              :class="{ selected: selectedPlatform == platform.val }"
              @click="select(platform)"
            >
              <!-- img/flags/ru.svg -->
              <img :src="platform.icon" class="flag ad fnone" /><span
                class="ddlabel"
                >{{ platform.title }}</span
              >
              <div class="clear"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const platformMapper = (el) => ({
  fullName: el.fullName,
  title: el.name,
  icon: require(`@/assets/flags/${el.imgName ? el.imgName : 'ru.svg'}`),
  val: el.id,
})

export default {
  data() {
    return {
      opened: false,
    }
  },
  methods: {
    select(item) {
      const route = {
        name: this.$route.name,
        params: this.$route.params,
      }
      if (item.fullName) {
        const [market, ticker] = item.fullName.split(':')
        route.params.market = market
        route.params.ticker = ticker
      } else route.params.market = item.title
      this.$router.push(route).catch() // duplicate route catch
    },
  },
  computed: {
    ...mapState('market', {
      selectedPlatform: 'platform',
      platforms: (state) => Array.from(state.platforms).map(platformMapper),
    }),
    selected() {
      const f = this.platforms.filter(
        (el) => el.val === this.$store.getters['market/platformId']
      )
      if (f.length === 1) return f[0]

      console.log('!!! platform not found, using first in platforms!')
      return this.platforms.slice(0, 1)
    },
  },
}
</script>

<style lang="scss">
.hover {
  &:hover {
    color: $primary-color2;
  }
}

.select-user-option {
  text-align: left;
  position: relative;
  display: table;

  &:before {
    width: 100%;
    height: 100%;
    content: '';
    left: 0;
    top: 80px;
    z-index: 1;
  }
  &:hover {
    cursor: pointer;
  }

  .dd.ddcommon {
    position: relative;
    padding-right: 20px !important;
    display: inline-block;

    &:after {
      position: absolute;
      content: '\f107';
      height: 10px;
      line-height: 0.625rem;
      width: 10px;
      font-family: FontAwesome;
      top: 50%;
      right: 0px;
      transform: translateY(-50%);
    }

    &.borderRadiusTp:after {
      transform: translateY(-50%) rotate(180deg);
    }
    &:hover {
      .ddlabel {
        @extend .hover;
        cursor: pointer;
      }
    }
  }
  span#countries_title {
    display: flex;
    align-items: center;
  }

  div#countries_msdd {
    width: auto !important;
    padding: 5px 0px;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #000;
    img {
      border: 1px solid #c2c2d6;
      width: 24px;
      height: auto;
      display: inline-block;
      overflow: hidden;
      margin-right: 10px;
      margin-top: -3px;
    }
  }
  div#countries_child {
    background: #373833;
    padding: 5px 10px;
    min-width: 157px;
    right: -10px;
    top: 40px !important;
    height: auto !important;
    background: #ffffff;
    /* Shadow */

    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 4px 16px rgba(0, 0, 0, 0.16);
    border-radius: 4px;

    li.enabled._msddli_ {
      padding: 5px 0;

      &:hover {
        color: $primary-color2;
        cursor: pointer;
      }

      &.selected .ddlabel {
        font-weight: 600;
      }
    }
  }
}
</style>
